import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    colors: {
      bgColor: '#fff',
      layers: {
        c1: '#fff',
        c2: '#fff',
        c3: '#fff',
        c4: '#fff',
        c5: '#fff',
        c6: '#fff',
        c7: '#fff',
        c8: '#fff',
        c9: '#fff',
        c10: '#fff',
        c11: '#fff',
        line: '#000',
      },
    },
  },
  mutations: {
    SET_COLORS:(state, colors) => {
      state.colors = colors
    },
  },
  actions: {
    setColors: ({ commit }, colors) => {
      console.log(colors)
      commit('SET_COLORS', colors)
    },
  },
})
